import { axiosOrderInstance } from "config/axios";
import { useAxiosMutation } from "hooks";
import { CancellationReason } from "modules/orders/enums";
import { useQueryClient } from "react-query";

type UseCancelOrderPayload = Partial<{
  reason: CancellationReason;
  other: string | null;
}>;

function useCancelOrder(orderId: string, encounterId: string) {
  const queryClient = useQueryClient();

  return useAxiosMutation(
    ["cancelOrder", { orderId }],
    (body?: UseCancelOrderPayload) =>
      axiosOrderInstance.put(`v1/${orderId}/cancel`, body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["encounterOrder", { orderId }]);
        queryClient.invalidateQueries(["encounterOrders", { encounterId }]);
        queryClient.invalidateQueries([
          "encounterOrderElementIds",
          encounterId,
        ]);
        queryClient.invalidateQueries([
          "orderHistoryPagination",
          { encounterId },
        ]);
        queryClient.invalidateQueries([
          "chartSidebarIndicators",
          { encounterId },
        ]);
        queryClient.invalidateQueries([
          "chartSectionIndicator",
          { encounterId },
        ]);
        queryClient.invalidateQueries([
          "chartSharedSectionIndicator",
          { encounterId },
        ]);
        queryClient.invalidateQueries([
          "encounterCancellationOrderCounters",
          { encounterId },
        ]);
        queryClient.invalidateQueries(["orderChart", { encounterId }]);
        queryClient.invalidateQueries(["ekg", { encounterId }]);
        queryClient.invalidateQueries(["ekgCounters", { encounterId }]);
        queryClient.invalidateQueries(["medsAndIvCounters", { encounterId }]);
        queryClient.invalidateQueries(["treatmentsCounters", { encounterId }]);
        queryClient.invalidateQueries([
          "encounterOrderCounters",
          { encounterId },
        ]);
      },
    }
  );
}

export { useCancelOrder };
